import React, { useState, useEffect } from "react";
import { Grid, TextField, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SweetAlert from "../../components/SweetAlert";
import api from "../../_api";
import Logo from "../../assets/images/Logo.png";
import "../../assets/css/login.css";
import "../../assets/css/Button.css";
import { useAuth } from "../../hooks/useAuth";
import Header from "components/Header";

function Login() {
  const { login, packageTypes, loading } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [values, setValues] = useState({ email: "", password: "" });
  const [packagesLoaded, setPackagesLoaded] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.login(values, {
        withCredentials: true,
      });
      // Assuming `data` contains the token directly
      if (data && data.token) {
        login(data.token, navigate); // Pass navigate to login function
        setIsSuccess(true);
        setShowAlert(true);
        setValues({ email: "", password: "" });
      } else {
        setIsSuccess(false);
        setShowAlert(true);
        setErrorMessage(data?.errors.email);
      }
    } catch (error) {
      setIsSuccess(false);
      setShowAlert(true);
      console.error("Login failed:", error.message);
    }
  };

  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [showAlert]);

  useEffect(() => {
    if (isSuccess && !loading) {
      setPackagesLoaded(true);
    }
  }, [isSuccess, loading]);

  useEffect(() => {
    if (packagesLoaded) {
      const sortedPackageTypes = packageTypes.sort((a, b) => a - b);
      const smallestPackageType = sortedPackageTypes[0];

      switch (smallestPackageType) {
        case 1:
          navigate("/pawn");
          break;
        case 2:
          navigate("/car");
          break;
        case 3:
          navigate("/land");
          break;
        default:
          navigate("/error");
          break;
      }
    }
  }, [packagesLoaded, packageTypes, navigate]);

  return (
    <div className="login-page">
      <Header />
      <Paper
        className="login-form"
        sx={{
          padding: 10,
          borderRadius: "12px",
          width: "600px",
          height: "700px",
          marginLeft: "auto",
          marginRight: "10rem",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={12}>
            <div className="logo-container">
              <img src={Logo} alt="Logo" className="logo" />
            </div>
          </Grid>
          <Grid item xs={12}>
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2} justifyContent="center">
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    type="text"
                    label="Username"
                    sx={{ width: 400 }}
                    name="email"
                    value={values.email}
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                    InputProps={{ sx: { borderRadius: "12px" } }}
                    autoComplete="username"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <TextField
                    type="password"
                    label="Password"
                    sx={{ width: 400 }}
                    name="password"
                    value={values.password}
                    onChange={(e) =>
                      setValues({ ...values, [e.target.name]: e.target.value })
                    }
                    InputProps={{ sx: { borderRadius: "12px" } }}
                    autoComplete="current-password"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    type="submit"
                    className="button-two-tone"
                    variant="contained"
                  >
                    Login
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Paper>
      {showAlert && (
        <SweetAlert
          title={isSuccess ? "Login successful" : "Login failed"}
          text={isSuccess ? "" : errorMessage}
          icon={isSuccess ? "success" : "error"}
          onClose={() => setShowAlert(false)}
        />
      )}
    </div>
  );
}

export default Login;
